import React from 'react';
import { Avatar, Button, Descriptions, Modal, Tag } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';

import ImgLink from './imgLink';

const PREVIEW_STYLE = {
  objectFit: 'contain',
  width: '100%',
  maxHeight: 320,
  borderRadius: 6,
  background: '#f5f5f5',
};

function formatDate(value) {
  return value ? moment.utc(value).format('YYYY-MM-DD HH:mm [UTC]') : '—';
}

/**
 * Read-only detail view for a post from GET /admin/posts list payload.
 */
export default function PostDetailModal({ post, open, onClose }) {
  if (!post) return null;

  const author = post.author || {};
  const tags = Array.isArray(post.tags) ? post.tags : [];

  return (
    <Modal
      visible={open}
      title="Post details"
      onCancel={onClose}
      width={720}
      destroyOnClose
      footer={(
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
          <Button onClick={onClose}>Close</Button>
          <Link to={`/posts/${post._id}/edit`} onClick={onClose}>
            <Button type="primary">Edit post</Button>
          </Link>
        </div>
      )}
    >
      <div className="post-detail-modal__image">
        <ImgLink imageStyle={PREVIEW_STYLE} link={post.image} />
      </div>

      <Descriptions bordered size="small" column={1} style={{ marginTop: 16 }}>
        <Descriptions.Item label="Post ID">{post._id || '—'}</Descriptions.Item>
        <Descriptions.Item label="Instock ID">{post.instockId || '—'}</Descriptions.Item>
        <Descriptions.Item label="Content">
          {post.content ? (
            <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{post.content}</div>
          ) : (
            <span style={{ color: 'rgba(0,0,0,0.45)' }}>No content</span>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Image URL">
          {post.image ? (
            <a href={/^https?:\/\//i.test(post.image) ? post.image : undefined} target="_blank" rel="noopener noreferrer">
              <span style={{ wordBreak: 'break-all' }}>{post.image}</span>
            </a>
          ) : '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Tags">
          {tags.length === 0 ? (
            'No tags'
          ) : (
            <div className="posts-list__tags">
              {tags.map((tag, index) => (
                <Tag color="geekblue" key={typeof tag === 'string' ? tag : index}>
                  {typeof tag === 'string' ? tag : (tag && tag.title) || '—'}
                </Tag>
              ))}
            </div>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Author">
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <Avatar src={author.image} size={32}>
              {(author.username || '?').charAt(0).toUpperCase()}
            </Avatar>
            <span>{author.username || '—'}</span>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label="Author ID">{author._id || '—'}</Descriptions.Item>
        <Descriptions.Item label="Author email">{author.email || '—'}</Descriptions.Item>
        <Descriptions.Item label="Likes">
          {post.totalNumberOfLikes == null ? 0 : post.totalNumberOfLikes}
        </Descriptions.Item>
        <Descriptions.Item label="Comments">
          {post.totalNumberOfComments == null ? 0 : post.totalNumberOfComments}
        </Descriptions.Item>
        <Descriptions.Item label="Deleted">
          {post.isDeleted ? <Tag color="red">Yes</Tag> : <Tag color="green">No</Tag>}
        </Descriptions.Item>
        <Descriptions.Item label="Created At">{formatDate(post.createdAt)}</Descriptions.Item>
        <Descriptions.Item label="Updated At">{formatDate(post.updatedAt)}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}
